/**
 * Function to recursively clean an object from any null, undefined, or empty string values.
 * This is used to clean up the variables object before passing it to the useQuery hook, in order
 * to reduce the amount of unnecessary calls to the API.
 */
export const cleanObject = (input) => {
    if (!input) {
        return {};
    }
    const validValue = (value) => value != null && value !== '';
    return Object.entries(input).reduce((acc, [key, value]) => {
        if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
            const cleaned = cleanObject(value);
            if (Object.keys(cleaned).length > 0) {
                return Object.assign(Object.assign({}, acc), { [key]: cleaned });
            }
            return acc;
        }
        if (validValue(value)) {
            return Object.assign(Object.assign({}, acc), { [key]: value });
        }
        return acc;
    }, {});
};
